import { render, staticRenderFns } from "./Optimization.vue?vue&type=template&id=556051dc&scoped=true"
import script from "./Optimization.vue?vue&type=script&lang=js"
export * from "./Optimization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556051dc",
  null
  
)

export default component.exports